import { RedirectRequest } from '@azure/msal-browser';
import { action } from 'satcheljs';

export const onPubCenterAADLogin = action('onPubCenterAADLogin', (requestParams?: Partial<RedirectRequest>) => ({ requestParams }));
